// Trailmap L2 Drip 3 — artifact expansion set reducer. fanReducer is
// toggle-only; this adds collapseAll (flat-pill / ESC / ⋯ menu) plus
// idempotent expand/collapse. Same-ref returns on no-op keep React from
// re-rendering. Insertion order (Set) is load-bearing for maps-cap
// eviction (oldest map = first inserted).
export type ArtifactExpandAction =
  | { type: 'toggle'; id: string }
  | { type: 'expand'; id: string }
  | { type: 'collapse'; id: string }
  | { type: 'collapseAll' };

export function artifactExpandReducer(
  state: ReadonlySet<string>,
  action: ArtifactExpandAction,
): ReadonlySet<string> {
  switch (action.type) {
    case 'collapseAll':
      return state.size === 0 ? state : new Set();
    case 'expand': {
      if (state.has(action.id)) return state;
      const next = new Set(state);
      next.add(action.id);
      return next;
    }
    case 'collapse': {
      if (!state.has(action.id)) return state;
      const next = new Set(state);
      next.delete(action.id);
      return next;
    }
    case 'toggle': {
      const next = new Set(state);
      if (next.has(action.id)) next.delete(action.id);
      else next.add(action.id);
      return next;
    }
    default:
      return state;
  }
}
